export default function uppercase(value) {
  const uppercase = /[A-Z]/;
  if (!uppercase.test(value)) {
    return 'uppercase';
  }

  return null;
}
